$(document).ready(function() {
    helperLoader.hide();
});